import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { AcceptedFiles } from '@insurancemenu/imenu-components-lib/dist/types/FileUpload';
import { getInitialSeedUploadUrls } from 'api/operations/productServiceV2';
import { uploadFiles } from 'global/utils/uploadFiles';
import { action, autorun, computed, makeObservable, observable } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';
import { getRootStoreInstance } from 'store/rootStore';
import { UploadUrls } from 'types/carrierFileService';

export default class UploadJSONModalDelegate extends ModalDelegate {
  private _rootStore = getRootStoreInstance();
  private _isFileUploadReset: boolean = false;

  private _setIsFileUploadReset(status: boolean): void {
    this._isFileUploadReset = status;
  }

  public get isFileUploadReset(): boolean {
    return this._isFileUploadReset;
  }

  public uploadJsonFile = async (files: AcceptedFiles): Promise<void> => {
    this.setIsLoading(true);
    // Get the uploaded file name
    const uploadedFileNames = Object.keys(files);

    // Handle errors in first REST request
    try {
      // Send file names and get list of urls
      const res = await getInitialSeedUploadUrls(this._rootStore.domainStoreV2.sponsorId, uploadedFileNames);

      // Handle errors in uploadFiles
      await uploadFiles(files, res as UploadUrls);

      this.setIsLoading(false);
    } catch (error) {
      this.setIsLoading(false);
      toastManager.addToast(error as string, ToastColorTypes.WARNING);
    }
  };

  constructor() {
    super();
    makeObservable<UploadJSONModalDelegate, '_isFileUploadReset' | '_setIsFileUploadReset'>(this, {
      _isFileUploadReset: observable,
      _setIsFileUploadReset: action.bound,
      isFileUploadReset: computed,
      uploadJsonFile: action.bound,
    });

    autorun(() => {
      if (this.isVisible) {
        this._setIsFileUploadReset(false);
      } else {
        this._setIsFileUploadReset(true);
      }
    });
  }
}
